export const locale = {
    lang: 'en',
    data: {
        'QUICK_PANNEL': {
            'NOTIFICATIONS': 'Notifications',
            'NEW_EMAIL_FROM': 'New email from',
            'DATE': 'Date',
            'SUBJECT': 'Subject',
            'NEW_TICKET': 'New Ticket',
            'NEW_ASSIGNED_TICKET': 'New assigned ticket',
            'NEW_TICKET_MESSAGE': 'New ticket message',
            'MESSAGE': 'Message',
            'NEW_ASSIGNED_EVENT': 'New assigned event',
            'CREATOR': 'Creator',
            'TYPE': 'Type',
            'CLIENT': 'Client',
            'LEAD': 'Lead',
            'NEW_DOC_FROM': 'New document from',
            'DOC_TYPE': 'Document Type',
            'NEW_UPCOMING_EVENT': 'New upcoming event',
            'ADD_PAYMENT_METHOD': 'add new payment method',
            'METHOD_TYPE': 'Method type', 
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/main/quick-panel/i18n/en.ts